/* istanbul ignore file */
import type {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common';
import {GridType, ImageModeId, ratioIdToRatioMap} from '../../../../types/galleryTypes';

export const promotionItemCustomCssVars = ({styleParams: styles}: CustomCssVarsFnParams) => {
  const isCrop = styles.numbers.gallery_promoCardsImageMode === ImageModeId.Crop;

  const getPromoCardsImagePosition = (): string => {
    if (isCrop) {
      return '50% 50%';
    }
    const isFixedGrid = styles.numbers.gallery_gridType === GridType.MANUAL;
    const isSingleColumn = isFixedGrid && styles.numbers.galleryColumns === 1;
    return isSingleColumn ? '50% 50%' : '50% 0%';
  };

  return {
    promoItemImageRatio: String(ratioIdToRatioMap[styles.numbers.galleryImageRatio]),
    promoCardsImageModeFit: isCrop ? 'cover' : 'contain',
    promoCardsImagePosition: getPromoCardsImagePosition(),
    promoItemAlignSelf: isCrop ? 'stretch' : 'start',
    promoItemHeight: isCrop ? '100%' : 'auto',
  };
};
